import Cookies from 'js-cookie'

export const isSubOnlyRegistration = () => {
  const urlParams = new URLSearchParams(window.location.search)

  return urlParams.get('subOnly') === 'true' || Cookies.get('subOnly') === 'true'
}
